import React from "react";
import { useState } from "react";
import DashboardDetails from "./DashboardDetails";
import DashboardCountDetails from "./DashboardCountDetails";
import Pagination from "../Pagination";

import { useSelector } from "react-redux";
const OrderRequestsAdmin = ({ tableData, setTableData }) => {
  const statusType = useSelector((state) => state.messageDetail);
  const [currentPage, setCurrentPage] = useState(1);
  const numberPerPage = 5;
  const indexOfLastArticle = currentPage * numberPerPage;
  const indexOfFirstArticle = indexOfLastArticle - numberPerPage;
  const paginate = (number) => setCurrentPage(number);
  return (
    <React.Fragment>
      <div className="dashboard_detail_container">
        <DashboardCountDetails
          totalRequests={tableData.message.length}
          statusType={statusType}
        />

        <div className="request-details">
          <div className="request_headers">
            <h2>Request Details</h2>
          </div>
          <table className="request-lists">
            <tbody>
              <tr>
                <th>Message</th>
                <th>Name</th>
                <th>Order Detail</th>
                <th>Total Price</th>
                <th>Service Type</th>
                <th>Status</th>
                <th>Send Date</th>
                <th>Actions</th>
              </tr>

              <DashboardDetails
                indexOfFirstArticle={indexOfFirstArticle}
                indexOfLastArticle={indexOfLastArticle}
                tableData={tableData.message}
                setTableData={setTableData}
                actions={["Read", "Pending", "Completed", "Rejected"]}
                type="requests"
                editable={false}
                deletable={true}
              />
            </tbody>
          </table>
          <Pagination
            numberPerPage={numberPerPage}
            totalArticles={tableData.message.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderRequestsAdmin;
